// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"abef66b7","594":"72c42277","766":"e758429c","970":"1995c076"}[chunkId] + ".chunk.js";
};